import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { removeFavourite } from "../../Components/redux/favouritesSlice";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { emptyCart, trash } from "../../assets/images";

const Favourites = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Aktif dili alıyoruz
  const navigate = useNavigate();

  const favourites = useSelector((state) => state.favourites.items);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const getLocalizedField = (item, fieldBase) => {
    if (currentLanguage === "en")
      return item[`${fieldBase}En`] || item[fieldBase];
    if (currentLanguage === "ru")
      return item[`${fieldBase}Ru`] || item[fieldBase];
    return item[fieldBase];
  };

  const userId = useSelector((state) => state.user.id);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  useEffect(() => {
    if (!isLoggedIn || !userId) {
      navigate(`/${currentLanguage}/login`);
      toast.error(t("Zəhmət olmasa giriş edin"));
    }
  }, [isLoggedIn, userId, currentLanguage, navigate, t]);

  // Ürün listesini çek (sadece 1 kere)
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(
          "https://www.elzabeauty.az/elza/dashboard.php"
        );
        setProducts(res.data.data || []);
      } catch (err) {
        console.error("Ürünler alınamadı:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  const getProductById = (id) => products.find((p) => p.id == id);

  const handleRemoveFavourite = async (product_id) => {
    if (!userId) return;
    try {
      await axios.delete("https://www.elzabeauty.az/elza/favourites.php", {
        data: new URLSearchParams({ user_id: userId, product_id }),
      });
      dispatch(removeFavourite(product_id));
      toast.error("Məhsul sevimlilərdən çıxarıldı");
    } catch (err) {
      console.error("Favoriden çıkarma hatası:", err);
      alert(t("Favorilerden çıxarılarkən bir xəta baş verdi."));
    }
  };

  if (loading)
    return <div className="text-center mt-8">{t("Yüklənir...")}</div>;

  if (favourites.length === 0) {
    return (
      <div className="flex flex-col mdl:flex-row justify-center items-center gap-4 py-20">
        <div>
          <img
            className="w-80 rounded-lg p-4 mx-auto"
            src={emptyCart}
            alt="emptyCart"
          />
        </div>
        <div className="max-w-[500px] p-4 py-8 bg-white flex gap-4 flex-col items-center rounded-md shadow-lg">
          <h1 className="font-titleFont text-xl font-bold">
            {t("SEVİMLİLƏR BOŞDUR")}
          </h1>
          <p className="text-sm text-center px-10 -mt-2">
            {t(
              "Bütün kateqoriyalar üzrə ən son təqdim etdiyimiz məhsullarla tanış olun"
            )}
          </p>
          <Link to={`/${currentLanguage}/products`}>
            <button className="bg-[#181D27] rounded-md cursor-pointer hover:bg-black active:bg-gray-900 px-8 py-2 font-titleFont font-semibold text-lg text-gray-200 hover:text-white duration-300">
              {t("Məhsullara keçid et")}
            </button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-containerSm md:max-w-container mx-auto py-10 md:py-20">
      <h2 className="text-[20px] md:text-[24px] font-medium text-[#181D27]">
        {t("Sevimlilərim")} ({favourites.length} {t("məhsul")})
      </h2>
      <ul className="space-y-4 mt-6 md:mt-10">
        {favourites.map((product_id) => {
          const product = getProductById(product_id);
          return (
            <li
              key={product_id}
              className="border rounded-md flex justify-between items-center w-full md:w-[714px] h-[112px] md:h-[124px] py-3 px-5"
            >
              <div className="flex gap-5 items-center">
                <img
                  className="md:w-[118px] w-[94px] h-[80px] md:h-[100px] object-cover rounded-[4px]"
                  src={`https://www.elzabeauty.az/elza/${product.image1}`}
                  alt={product.name || "Product image"}
                />
                <div>
                  {getLocalizedField(product, "secondPrice") ? (
                    <h4 className="text-[18px] md:text-[24px] font-medium mt-5">
                      <span className="line-through text-[#697586] mr-2">
                        {getLocalizedField(product, "firstPrice")} ₼
                      </span>
                      <span className="text-firstColor">
                        {getLocalizedField(product, "secondPrice")} ₼
                      </span>
                    </h4>
                  ) : (
                    <h4 className="text-[18px] md:text-[24px] font-medium mt-5">
                      {getLocalizedField(product, "firstPrice")} ₼
                    </h4>
                  )}
                  <p className="text-[#181D27]">
                    {product ? product.name : t("Yüklənir...")}
                  </p>
                </div>
              </div>
              <button
                onClick={() => handleRemoveFavourite(product_id)}
                aria-label={t("Favorilerden çıkar")}
              >
                <img alt="Trash" className="h-6 w-6" src={trash}></img>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Favourites;
